import PropTypes from 'prop-types';

export const ProductListDefaultProps = {
  className: '',
  parent: null,
  selectedItem: null,
  isOpen: false,
  isRoot: true,
  panelIndex: null,
  panelWidth: null,
  onSelect: () => null,
};

export const ProductListPropTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  isRoot: PropTypes.bool,
  items: PropTypes.array.isRequired,
  parent: PropTypes.object,
  selectedItem: PropTypes.object,
  panelIndex: PropTypes.number,
  panelWidth: PropTypes.number,
  onSelect: PropTypes.func,
};
